module.exports = __webpack_public_path__ + "img/avatar6.ceb7e922.png";